// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import "./signIn.css";

// const API_BASE_URL = process.env.REACT_APP_EP || "http://localhost:5000";

// const SignIn = () => {
//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [agree, setAgree] = useState(false);

//   const [otp, setOtp] = useState("");
//   const [showOtpField, setShowOtpField] = useState(false);
//   const [otpToken, setOtpToken] = useState(null); // token returned by backend when OTP is sent

//   const [errors, setErrors] = useState({});
//   const [otpError, setOtpError] = useState("");
//   const [infoMessage, setInfoMessage] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // If already logged in in this browser session, redirect to home
//   // NEW
// useEffect(() => {
//   const checkAuth = async () => {
//     try {
//       const res = await fetch(`${API_BASE_URL}/api/auth/me`, {
//         method: "GET",
//         credentials: "include",  // send cookie
//       });

//       if (res.ok) {
//         // user is already logged in → redirect away from login page
//         navigate("/", { replace: true });
//       }
//       // if not ok, stay on login page
//     } catch (err) {
//       // network / other error → treat as not logged in
//     }
//   };

//   checkAuth();
// }, [navigate]);

//   const validateForm = () => {
//     const newErrors = {};
//     const trimmedEmail = email.trim();

//     if (!trimmedEmail) {
//       newErrors.email = "Email is required.";
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
//       newErrors.email = "Enter a valid email address.";
//     }

//     if (!password.trim()) {
//       newErrors.password = "Password is required.";
//     } else if (password.length < 6) {
//       newErrors.password = "Password must be at least 6 characters.";
//     }

//     if (!agree) {
//       newErrors.agree = "You must agree with the terms of use.";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleGenerateOtp = async (e) => {
//     e.preventDefault();
//     setInfoMessage("");
//     setOtpError("");
//     setErrors((prev) => ({ ...prev, credentials: undefined, server: undefined }));

//     if (!validateForm()) return;

//     try {
//       setIsSubmitting(true);

//       // 1) Verify email & password
//       const loginRes = await fetch(`${API_BASE_URL}/api/auth/login-step`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, password }),
//       });

//       const loginData = await loginRes.json();

//       if (!loginRes.ok || loginData.success === false) {
//         setShowOtpField(false);
//         setOtpToken(null);
//         setErrors((prev) => ({
//           ...prev,
//           credentials:
//             loginData.error || loginData.message || "Invalid email or password.",
//         }));
//         return;
//       }

//       // 2) Send OTP
//       const otpRes = await fetch(`${API_BASE_URL}/api/auth/send-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email }),
//       });

//       const otpData = await otpRes.json();

//       if (!otpRes.ok || otpData.success === false) {
//         setShowOtpField(false);
//         setOtpToken(null);
//         setOtpError(otpData.error || otpData.message || "Failed to send OTP.");
//         return;
//       }

//       // Assuming backend returns an otpToken here
//       setOtpToken(otpData.otpToken);
//       setShowOtpField(true);
//       setOtp("");
//       setInfoMessage(
//         otpData.message || "A 6-digit OTP has been sent to your email address."
//       );
//     } catch (error) {
//       console.error("Error during login-step/send-otp:", error);
//       setErrors((prev) => ({
//         ...prev,
//         server: "Something went wrong. Please try again.",
//       }));
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleVerifyOtp = async (e) => {
//     e.preventDefault();
//     if (!showOtpField) return;

//     const cleanedOtp = otp.replace(/[\s\u200B-\u200D\uFEFF]/g, "").trim();

//     if (!/^\d{4}$/.test(cleanedOtp)) {
//       setOtpError("OTP must be a 4-digit number.");
//       return;
//     }

//     if (!otpToken) {
//       setOtpError("Missing OTP token. Please generate a new OTP.");
//       return;
//     }

//     try {
//       setIsSubmitting(true);
//       setOtpError("");

//       const res = await fetch(`${API_BASE_URL}/api/auth/verify-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         credentials: "include",
//         body: JSON.stringify({
//           email,
//           otp: cleanedOtp,
//           otpToken,
//         }),
//       });

//       const data = await res.json();
//       console.log("verify-otp response:", res.status, data);

//       if (!res.ok || data.success === false) {
//         setOtpError(
//           data.error || data.message || "Incorrect OTP. Please try again."
//         );
//         return;
//       }

//       // Cookie is now set; no need to store JWT
//       localStorage.setItem("isLoggedIn", "true"); // optional helper flag
//       navigate("/", { replace: true });

//     } catch (error) {
//       console.error("Error during verify-otp:", error);
//       setOtpError("Unable to verify OTP. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const isGenerateDisabled = !email || !password || !agree || isSubmitting;
//   const isVerifyDisabled = !showOtpField || otp.length !== 4 || isSubmitting;

//   return (
//     <div className="signin-page">
//       <div className="signin-left" />

//       <div className="signin-right">
//         <form className="signin-form" onSubmit={handleVerifyOtp}>
//           <h1 className="signin-title">Log In</h1>

//           <div className="form-group">
//             <label className="form-label">Email</label>
//             <input
//               type="email"
//               className="text-input"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               autoComplete="email"
//             />
//             {errors.email && <div className="field-error">{errors.email}</div>}
//           </div>

//           <div className="form-group">
//             <label className="form-label">Password</label>
//             <input
//               type="password"
//               className="text-input"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               autoComplete="current-password"
//             />
//             {errors.password && (
//               <div className="field-error">{errors.password}</div>
//             )}
//             {errors.credentials && (
//               <div className="field-error">{errors.credentials}</div>
//             )}
//           </div>

//           <div className="checkbox-row">
//             <input
//               id="agree"
//               type="checkbox"
//               checked={agree}
//               onChange={(e) => setAgree(e.target.checked)}
//             />
//             <label htmlFor="agree" className="checkbox-label">
//               I agree with the terms of use
//             </label>
//           </div>
//           {errors.agree && (
//             <div className="field-error margin-bottom">{errors.agree}</div>
//           )}

//           {errors.server && (
//             <div className="field-error margin-bottom">{errors.server}</div>
//           )}

//           <button
//             type="button"
//             className="primary-button full-width"
//             onClick={handleGenerateOtp}
//             disabled={isGenerateDisabled}
//           >
//             {isSubmitting ? "Please wait..." : "Generate OTP"}
//           </button>

//           {infoMessage && <div className="info-text">{infoMessage}</div>}

//           {showOtpField && (
//             <>
//               <div className="otp-title">
//                 Enter OTP received to Above Email ID
//               </div>

//               <div className="form-group">
//                 <input
//                   type="text"
//                   className="text-input"
//                   value={otp}
//                   onChange={(e) => setOtp(e.target.value)}
//                   maxLength={4}
//                 />
//                 {otpError && <div className="field-error">{otpError}</div>}
//               </div>

//               <button
//                 type="submit"
//                 className="primary-button full-width"
//                 disabled={isVerifyDisabled}
//               >
//                 {isSubmitting ? "Verifying..." : "Verify OTP and Login"}
//               </button>
//             </>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// };

// export default SignIn;

// SignIn/signIn.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./signIn.css";

const API_BASE_URL = process.env.REACT_APP_EP || "http://localhost:5000";

const SignIn = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [agree, setAgree] = useState(false);

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // If already logged in, redirect to home
    useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/auth/me`, {
          method: "GET",
          credentials: "include",
        });

        if (res.ok) {
          const data = await res.json();
          if (data?.user?.name) {
            localStorage.setItem("userName", data.user.name);
          }
          navigate("/", { replace: true });
        }
      } catch (err) {
        // treat as not logged in
      }
    };

    checkAuth();
  }, [navigate]);

  const validateForm = () => {
    const newErrors = {};
    const trimmedName = name.trim();

    if (!trimmedName) {
      newErrors.name = "Name is required.";
    }

    

    if (!agree) {
      newErrors.agree = "You must agree with the terms of use.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors((prev) => ({ ...prev, credentials: undefined, server: undefined }));

    if (!validateForm()) return;

    try {
      setIsSubmitting(true);

      const res = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include", // important so cookie is stored
        body: JSON.stringify({ name, password }),
      });

      const data = await res.json();

            if (!res.ok || data.success === false) {
        setErrors((prev) => ({
          ...prev,
          credentials:
            data.error || data.message || "Invalid name or password.",
        }));
        return;
      }

      // Get display name from server if available, otherwise fall back to what user typed
      const loggedInName =
        data?.user?.name || data?.name || name;

      // Optional helper flag; main auth is via cookie
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("userName", loggedInName); // <-- store name

      navigate("/", { replace: true });

      // Optional helper flag; main auth is via cookie
      localStorage.setItem("isLoggedIn", "true");

      navigate("/", { replace: true });
    } catch (error) {
      console.error("Error during login:", error);
      setErrors((prev) => ({
        ...prev,
        server: "Something went wrong. Please try again.",
      }));
    } finally {
      setIsSubmitting(false);
    }
  };

  const isSubmitDisabled = !name || !password || !agree || isSubmitting;

  return (
    <div className="signin-page">
      <div className="signin-left" />

      <div className="signin-right">
        <form className="signin-form" onSubmit={handleSubmit}>
          <h1 className="signin-title">Log In</h1>

          <div className="form-group">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="text-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoComplete="username"
            />
            {errors.name && <div className="field-error">{errors.name}</div>}
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="text-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            {errors.password && (
              <div className="field-error">{errors.password}</div>
            )}
            {errors.credentials && (
              <div className="field-error">{errors.credentials}</div>
            )}
          </div>

          <div className="checkbox-row">
            <input
              id="agree"
              type="checkbox"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
            />
            <label htmlFor="agree" className="checkbox-label">
              I agree with the terms of use
            </label>
          </div>
          {errors.agree && (
            <div className="field-error margin-bottom">{errors.agree}</div>
          )}

          {errors.server && (
            <div className="field-error margin-bottom">{errors.server}</div>
          )}

          <button
            type="submit"
            className="primary-button full-width"
            disabled={isSubmitDisabled}
          >
            {isSubmitting ? "Please wait..." : "Log In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignIn;